import { GetLinkedDevicesInput } from 'src/API';
import { useAppSelector } from 'src/stores/slices/hooks';
import { selectSelectedSiteCodes } from 'src/stores/slices/userPrefsSlice';

export function useSitesWithCodes() {
  const allowedSites = useAppSelector(state => state.deviceState.allowedSites);
  const selectedSiteCodes = useAppSelector(selectSelectedSiteCodes);

  const sitesWithCodes = selectedSiteCodes
    .map(selectedSite => {
      const foundSite = allowedSites.find(
        site => site.SiteCode === selectedSite
      );

      if (!foundSite) return;

      return {
        region: foundSite.region,
        regionWithCampus: foundSite.regionWithCampus,
        site: foundSite.SiteCode,
      };
    })
    .filter(Boolean) as GetLinkedDevicesInput[];

  return { sitesWithCodes };
}
